import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

import anchorScroll from './components/anchorScroll';
import scrollToUp from './components/scrollToUp';
import { initBlock } from './blocks';

const blockNames = [
  "sample-block-1"
];

for (const item of blockNames) {
  initBlock(item).then((blocks) => {});
}

import 'flowbite';

// Dodaj funkcję inicjalizacji Sticky JS
function initSticky() {
  const stickyElement = document.querySelector('.sticky-sidebar');
  if (stickyElement) {
    return new Sticky('.sticky-sidebar');
  }
  return null;
}

// Inicjalizuj Sticky JS
let sticky = null;
document.addEventListener('DOMContentLoaded', function() {
  sticky = initSticky();

  function handleResize() {
    if (window.innerWidth < 768) { // ustaw szerokość graniczną według własnych potrzeb
      if (sticky) {
        sticky.destroy(); // usuwa instancję sticky na urządzeniach mobilnych
        sticky = null;
      }
    } else {
      if (!sticky) {
        sticky = initSticky(); // ponownie inicjalizuje instancję sticky na większych ekranach
      } else {
        sticky.update(); // aktualizuje istniejącą instancję sticky
      }
    }
  }

  // Nasłuchuj zdarzenia zmiany rozmiaru okna
  window.addEventListener('resize', handleResize);

  // Wywołaj funkcję przy pierwszym załadowaniu strony
  handleResize();

  // Dodatkowa funkcjonalność (kolorowanie przycisków dodawania do koszyka)
  var addToCartButtons = document.querySelectorAll('.single_add_to_cart_button');
  addToCartButtons.forEach(function(button) {
    button.classList.add('bg-rose-600');
  });


  var moreReviewsButton = document.getElementById("more_reviews");
  var reviewsContainer = document.querySelector(".reviews-container");

  if (moreReviewsButton && reviewsContainer) {
    moreReviewsButton.addEventListener("click", function() {
      reviewsContainer.classList.toggle("expanded");
      moreReviewsButton.classList.toggle("expanded");
      moreReviewsButton.textContent = reviewsContainer.classList.contains("expanded") ? "Pokaż mniej" : "Pokaż więcej";
    });
  }


});


